import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Users, Gift, Copy, Check, Share2 } from 'lucide-react';

const ReferralTab = ({ user }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  // لینک مستقیم مینی‌اپ با نام کاربری ربات و short_name
  const botUsername = 'CryptooPredictionBot';
  const appShortName = 'app'; // یا هر اسم کوتاهی که در BotFather گذاشتید
  
  const inviteCode = user?.invite_code || user?.referral_code || '';
  const referralLink = `https://t.me/${botUsername}/${appShortName}?startapp=${inviteCode}`;

  const handleCopyLink = () => {
    if (inviteCode) {
      navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleShareTelegram = () => {
    if (!inviteCode) return;
    const shareText = encodeURIComponent('Join CandleDuel to predict crypto prices and compete with other players! 🚀');
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${shareText}`;
    
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.openTelegramLink(shareUrl);
    } else {
      window.open(shareUrl, '_blank');
    }
  };

  return (
    <main className="p-4 flex-1 flex flex-col gap-4">
      <div className="bg-[#1A1528] p-5 rounded-3xl border border-white/5 space-y-4">
        <h3 className="font-bold text-base text-purple-300">{t('referral')}</h3>
        <p className="text-xs text-gray-400 leading-relaxed">{t('refDesc')}</p>

        <div className="grid grid-cols-2 gap-3 pt-2">
          <div className="bg-[#120F1D] p-3.5 rounded-2xl border border-white/5 text-center">
            <Users className="mx-auto text-purple-400 mb-1" size={18} />
            <div className="text-[10px] text-gray-400">Total Friends</div>
            <div className="font-bold text-base text-white mt-0.5">{user?.referral_count || 0}</div>
          </div>

          <div className="bg-[#120F1D] p-3.5 rounded-2xl border border-white/5 text-center">
            <Gift className="mx-auto text-amber-400 mb-1" size={18} />
            <div className="text-[10px] text-gray-400">Earned Bonus</div>
            <div className="font-bold text-base text-amber-400 mt-0.5">
              ${parseFloat(user?.referral_earnings || 0).toFixed(2)}
            </div>
          </div>
        </div>

        <div className="bg-[#120F1D] p-3 rounded-2xl border border-white/5 flex items-center justify-between mt-2">
          <div>
            <div className="text-[10px] text-gray-500">{t('yourCode')}</div>
            <div className="font-mono font-bold text-amber-400">{inviteCode || '---'}</div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handleCopyLink}
              className="bg-amber-500/10 text-amber-400 px-3 py-1.5 rounded-xl border border-amber-500/20 text-xs font-bold flex items-center gap-1 active:scale-95 transition-transform"
            >
              {copied ? <Check size={14} /> : <Copy size={14} />}
              <span>{copied ? t('copied') : t('copy')}</span>
            </button>
            <button
              onClick={handleShareTelegram}
              className="bg-purple-600 hover:bg-purple-500 text-white px-3 py-1.5 rounded-xl text-xs font-bold flex items-center gap-1 active:scale-95 transition-transform"
            >
              <Share2 size={14} />
              <span>{t('share')}</span>
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReferralTab;
